/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailsUnsubscribeBody model module.
 * @module model/EmailsUnsubscribeBody
 * @version 1.0.0
 */
export class EmailsUnsubscribeBody {
  /**
   * Constructs a new <code>EmailsUnsubscribeBody</code>.
   * @alias module:model/EmailsUnsubscribeBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsUnsubscribeBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsUnsubscribeBody} obj Optional instance to populate.
   * @return {module:model/EmailsUnsubscribeBody} The populated <code>EmailsUnsubscribeBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsUnsubscribeBody();
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('emailId'))
        obj.emailId = ApiClient.convertToType(data['emailId'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} propertyId
 */
EmailsUnsubscribeBody.prototype.propertyId = undefined;

/**
 * @member {String} emailId
 */
EmailsUnsubscribeBody.prototype.emailId = undefined;

/**
 * @member {String} email
 */
EmailsUnsubscribeBody.prototype.email = undefined;

